import { render, staticRenderFns } from "./Step2_KB.vue?vue&type=template&id=8d8e5b70&scoped=true"
import script from "./Step2_KB.vue?vue&type=script&lang=js"
export * from "./Step2_KB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8e5b70",
  null
  
)

export default component.exports